import React from 'react';
import SvgIcon from './SvgIcon';

const Cursor = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M10.972 22.694a.5.5 0 01-.942.054L1.538 2.188a.5.5 0 01.653-.653l20.56 8.492a.5.5 0 01-.054.942l-8.852 2.53a.5.5 0 00-.343.344l-2.53 8.85z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Cursor.displayName = 'CursorIcon';

export default Cursor;
